import React, { useState } from 'react';
import {
    makeStyles,
    Button,
    DialogTitle,
    Divider,
    DialogContent,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Dialog,
    DialogActions,
    Typography
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { createCategory } from '../../store/action';
import Notification from '../../components/Notification/Notification';

const useStyle = makeStyles((theme) => ({
    dialogWidth: { width: "100%", background: theme.palette.background.main },
    radioGroup: {
        flexDirection: "row"
    }
}))

const CreateCategory = ({ open, handleClose }) => {
    const classes = useStyle();
    const dispatch = useDispatch();
    const [specilaityNotify, setSpecilaityNotify] = useState(false)
    const { specialitySuccess, specialityError } = useSelector(state => state.candidateCategory)
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const [data, setData] = useState({
        category_name: "",
        category_description: "",
        status: ""
    })
    const [formError, setError] = useState([])
    const handleChange = (event) => {
        if (event.target.value) {
            setError([]);
        } else {
            if (event.target.name === "category_name") {
                setError('err_category_name');
            }
        }
        setData({ ...data, [event.target.name]: event.target.value });
    };

    const categorySubmit = (event) => {
        event.preventDefault();
        if (data.category_name === "") {
            setError('err_category_name');
        } else {
            setError([])
            dispatch(createCategory(data))
            setSpecilaityNotify(true)
            handleClose1();
        }
        // dispatch(createSpecialities(data))
        // setSpecilaityNotify(true)
        // handleClose();
        // reset();
    }

    const resetForm = () => {
        setError([])
        setData({ ...data, category_name: '', category_description: '' });
    }

    const handleClose1 = () => {
        resetForm();
        handleClose();
    }

    const statusList = [
        {
            id: "active",
            status_name: 'Active',
        },
        {
            id: "deactive",
            status_name: 'Inactive',
        }
    ];
    return (
        <>
            {specilaityNotify && specialitySuccess?.message &&
                <Notification
                    data={specialitySuccess?.message}
                    status="success"
                />
            }

            {specilaityNotify && specialityError?.message &&
                <Notification
                    data={specialityError?.message}
                    status="error"
                />
            }
            <Dialog open={open} onClose={handleClose1} classes={{ paper: classes.dialogWidth }}>
                <form>
                    <DialogTitle id="form-dialog-title">
                        <Typography variant="h6">Create Category</Typography>
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="CategoryName"
                                label="Category Name"
                                variant="outlined"
                                name="category_name"
                                fullWidth
                                required
                                value={data?.category_name || ""}
                                onChange={handleChange}
                                error={formError.includes("err_category_name")}
                                helperText={
                                    formError.includes("err_category_name")
                                        ? "Please enter category name"
                                        : ""
                                }
                            />

                            <TextField
                                margin="dense"
                                id="CategoryDescription"
                                label="Category Description"
                                variant="outlined"
                                name="category_description"
                                fullWidth
                                required
                                multiline
                                minRows={3}
                                value={data?.category_description || ""}
                                onChange={handleChange}
                                sx={{ mt: 2 }}
                            />

                            <FormControl
                                variant="outlined"
                                fullWidth
                                sx={{ mt: 4 }}
                            >
                                <InputLabel id="status-label">Status</InputLabel>
                                <Select
                                    labelId="status-label"
                                    id="status"
                                    name="status"
                                    value={data?.status || ""}
                                    label="Status"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="">Select Status</MenuItem>
                                    {statusList &&
                                        statusList.map((items) => (
                                            <MenuItem value={items.id} key={items.id}>
                                                {items.status_name}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions className="pr-4 pb-2">
                        <Button onClick={handleClose1} variant='outlined'>Cancel</Button>
                        <Button color="secondary" variant="contained" type="submit" onClick={(event) => categorySubmit(event)}>
                            Add
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    )
}

export default CreateCategory
